// ══════════════════════════════════════════════════════════════════════════════════════════════
//  DESCARGAR DESDE LA APP DEL MÓVIL: EL FICHERO, AL NAVEGADOR DEL TELÉFONO (16-oct-2026)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//
//  El dueño: «en el móvil si pulso descargar PDF, se abre el PDF pero no deja descargarlo», «tanto en la app de iPhone como de
//  Android; por navegador sí funciona bien; pasa lo mismo con los documentos en el chat de equipo». La app no tiene ningún
//  plugin para guardar ficheros y su vista web no descarga. Así que el fichero que la app ya tiene se sube al servidor
//  (POST /api/descargas/preparar, con la sesión) y su dirección, que vale unos minutos, se abre en el NAVEGADOR del teléfono,
//  que lo descarga o lo comparte como cualquier otro (backend/services/descargaFuera.js lo cuenta entero).
//
//  POR QUÉ «https://www.». Capacitor deja dentro de la app las direcciones de su servidor (https://biango.app) y le da al
//  sistema todo lo demás. https://www.biango.app es el MISMO servidor, con su certificado, y Capacitor no lo reconoce como
//  suyo: lo abre el navegador del teléfono. (La primera versión abría «http://» y la llave viajaba en claro hasta Cloudflare:
//  nunca más.) Con «https://biango.app» volvería a abrirse DENTRO de la app, que es justo lo que no descarga.
import api from '../services/api'
import { t } from './i18n.js'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export const rutaFuera = (ventana, ruta) => {
  const host = String(ventana.location.host || '')
  return 'https://' + (host.startsWith('www.') ? host : 'www.' + host) + ruta
}

// Devuelve { ok: true } o { ok: false, error }. Nunca lanza.
export async function descargarFueraDeLaApp({ blob, nombre } = {}, ventana) {
  const w = ventana || (typeof window !== 'undefined' ? window : null)
  if (!w || !blob) return { ok: false, error: t('utils.descargaFuera.no_hay_fichero_que_descargar', 'No hay fichero que descargar.') }
  try {
    const r = await api.post('/descargas/preparar', blob, {
      headers: { 'Content-Type': blob.type || 'application/octet-stream', 'X-Nombre': encodeURIComponent(nombre || 'documento') },
      transformRequest: [(d) => d],
    })
    w.location.href = rutaFuera(w, r.data.ruta)
    return { ok: true }
  } catch (e) {
    const msg = e && e.response && e.response.data && e.response.data.error
    return { ok: false, error: msg || t('utils.descargaFuera.no_se_ha_podido_preparar', 'No se ha podido preparar la descarga.') }
  }
}
